import { useMutation } from "react-query";

import { processEvent } from "@api/processEvent";

const useProcessEvent = (): { handleProcessEvent: (event: string) => void } => {
  const { mutate } = useMutation((event: string) => processEvent(event));

  const handleProcessEvent = (event: string): void => mutate(event);

  return {
    handleProcessEvent,
  };
};

export default useProcessEvent;
